import Service from "../Service"

const room = {

    getAllRoom() {
        return Service.get(`api/room`, {
            params: {
                paginate: false
            }
        });
    },
    getById(id) {
        return Service.get(`api/room/${id}`)
    },
    getAllRoomByLevel(levelId) {
        return Service.get(`api/room`, {
            params: {
                level_id: levelId,
                paginate: false
            }
        });
    },
    getAvailableRoomOffer(typeId) {
        return Service.get(`api/room/available/${typeId}`);
    },
    // Get room available and minimum by room type ID
    getRoomAvailableAndMinimumByRoomTypeId(typeId) {
        return Service.get(`api/room-available-and-minimum/${typeId}`)
    }
};

export default room;
